import { ProductKey } from 'src/app/core/enums/ProductKey';

type ProductLike = { ProductKey?: ProductKey | string | null } | null | undefined;

export function isTransitProductKey(productKey?: ProductKey | string | null): boolean {
    return productKey === ProductKey.Transit;
}

export function isTransitProduct(product?: ProductLike): boolean {
    return isTransitProductKey(product?.ProductKey);
}

export function hasTransitProduct(products?: ReadonlyArray<ProductLike> | null): boolean {
    return products?.some((product) => isTransitProduct(product)) ?? false;
}

export function hasTransitProductKey(productKeys?: ReadonlyArray<ProductKey | string | null | undefined> | null): boolean {
    return productKeys?.some((productKey) => isTransitProductKey(productKey)) ?? false;
}